<template>
  <div>
    <el-form
      ref="emailForm"
      label-position="right"
      label-width="150px"
      :model="mailForm"
      :rules="rules"
      v-show="!isSuccess"
      style="width:600px"
    >
      <el-form-item v-if="email != null && email != ''" label="原邮箱地址">
        {{ email }}
      </el-form-item>
      <el-form-item label="新绑定邮箱地址" prop="email">
        <el-input
          v-model="mailForm.email"
          placeholder="请输入要绑定的邮箱地址"
        ></el-input>
      </el-form-item>
      <el-form-item label="验证码" prop="vcode">
        <el-input
          v-model="mailForm.vcode"
          placeholder="请输入验证码（不分大小写）"
        >
          <el-button v-if="sendVCode" slot="append" @click="getAuthCode"
            >免费获取验证码</el-button
          >
          <el-button v-if="!sendVCode" slot="append"
            >{{ auth_time }} 秒后重新获取</el-button
          >
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">立即绑定</el-button>
        <el-button v-if="isSkip" @click="handleSkip">跳过</el-button>
      </el-form-item>
    </el-form>

    <el-result
      v-show="isSuccess"
      icon="success"
      title="成功提示"
      subTitle="您已绑定新的邮箱！"
    >
      <template slot="extra">
        <el-button type="primary" size="medium" @click="handleEmailBindingDone"
          >确定</el-button
        >
      </template>
    </el-result>
  </div>
</template>

<script>
export default {
  props: {
    email: String, // 编辑权限标识
    isSkip: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isSuccess: false,
      sendVCode: true /*布尔值，通过v-show控制显示‘获取按钮’还是‘倒计时’ */,
      auth_time: 0 /*倒计时 计数器*/,
      mailForm: {
        email: "",
        vcode: ""
      },
      rules: {
        email: [
          { required: true, message: "请输入邮箱地址", trigger: "blur" },
          {
            type: "email",
            message: "请输入正确的邮箱地址",
            trigger: ["blur"]
          }
        ],
        vcode: [{ required: true, message: "请输入验证码", trigger: "blur" }]
      }
    };
  },
  methods: {
    getAuthCode: function() {
      //单独验证表单email内容，注意error返回的是不通过的msg的信息，如果为空表示验证通过
      this.$refs["emailForm"].validateField("email", async error => {
        if (error) {
          return false;
        } else {
          this.sendVCode = false;
          this.auth_time = 30;
          var auth_timetimer = setInterval(() => {
            this.auth_time--;
            if (this.auth_time <= 0) {
              this.sendVCode = true;
              clearInterval(auth_timetimer);
            }
          }, 1000);

          //发送验证码
          this.getVcode();
        }
      });
    },
    //发送验证码
    getVcode: function() {
      this.$api.user.getEmailVcode(this.mailForm.email).then(res => {
        if (res.code == 200) {
          this.$alert(
            "验证码已经发送到邮箱，在20分钟内登录邮箱完成验证！",
            "操作成功",
            {
              confirmButtonText: "确定",
              callback: action => {
                return false;
              }
            }
          );
        } else {
          this.$message({
            message:
              "操作失败, [ code: " + res.code + "， message: " + res.msg + " ]",
            type: "error"
          });
        }
      });
    },
    //提交保存
    onSubmit: function(data) {
      //验证表单内容
      this.$refs["emailForm"].validate(valid => {
        if (!valid) {
          return false;
        } else {
          //如果验证码不正确不执行
          this.verifyVcode();
        }
      });
    },
    //验证验证码
    verifyVcode: function(data) {
      data = {
        object: this.mailForm.email,
        vcode: this.mailForm.vcode,
        type: "email"
      };

      this.$api.user.verifyVcode(data).then(res => {
        if (res.code == 200) {
          this.saveEmail();
        } else {
          this.$message({
            message:
              "操作失败, [ code: " + res.code + "， message: " + res.msg + " ]",
            type: "error"
          });

          return false;
        }
      });

      return false;
    },
    //更新邮件地址
    saveEmail: function(data) {
      if (this.mailForm.email == null || this.mailForm.email == "") return;
      this.$api.user
        .saveProfile({ email: this.mailForm.email })
        .then(res => {
          if (res.code == 200) {
            this.$message({
              message: "操作成功",
              type: "success"
            });
            this.isSuccess = true;
            //重要：刷新Session中的edzUser的邮件地址
          } else {
            this.$message({
              message:
                "操作失败, [ code: " +
                res.code +
                "， message: " +
                res.msg +
                " ]",
              type: "error"
            });
          }
        })
        .then(data != null ? data.callback : "");
    },
    //处理绑定完成后的动作
    handleEmailBindingDone: function() {
      this.$emit("handleEmailBindingDone", {
        type: "email",
        value: this.mailForm.email
      });
    },
    //处理跳过绑定按钮
    handleSkip: function() {
      this.$emit("handleSkip");
    }
  }
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/views/User/EmailBinding.vue